import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! @glint-nocheck: not typesafe yet }}\n<Hds::Badge @text={{t \"components.core.badge.new\"}} @color=\"highlight\" />")